import { styled } from '@mui/material/styles';
import { Box, Chip } from '@mui/material';

export const MessagesContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0
});

export const GridWrapper = styled(Box)({
  flex: 1,
  minHeight: 0,
  height: 'calc(100vh - 280px)'
});

export const DetailPanelContent = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(14),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1)
}));

export const PillChip = styled(Chip)({
  borderRadius: 16,
  fontWeight: 700,
  minWidth: 56,
  justifyContent: 'center'
});

export const PillChipGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const BulkActionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(1, 2)
}));
